import { render } from "./Overlays.vue?vue&type=template&id=5aad0f4f&ts=true"
import script from "./Overlays.vue?vue&type=script&lang=ts"
export * from "./Overlays.vue?vue&type=script&lang=ts"

import "./Overlays.vue?vue&type=style&index=0&id=5aad0f4f&lang=scss"

import exportComponent from "/home/node/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__